/* eslint-disable linebreak-style */
/* eslint-disable comma-dangle */
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import { TITLE_ID } from '../../Constants';
import './Bullshark.css';
import { gaEvents } from '../../util/events';
import Logout from '../Logout/Logout';

/**
This is an outdated component so no need to look at this. This was for the bullshark quest
that has ended
*/
function Bullshark({ activeTab, wallet }) {
  const [bullSharkNfts, setBullsharkNfts] = useState([]);
  const [activeNft, setActiveNft] = useState([]);
  const [isLinked, setIsLinked] = useState(false);
  const [isConfirming, setIsConfirming] = useState(false);
  const [connectedWallet, setConnectedWallet] = useState('');
  const [isDifferentWallet, setIsDifferentWallet] = useState(false);
  const [showLogout, setShowLogout] = useState(false);
  const [errorText, setErrorText] = useState(null);

  useEffect(() => {
    const nfts = [];
    if (wallet.contents) {
      wallet.contents.nfts.forEach((nft) => {
        if (nft.moduleName === 'suifrens') {
          nfts.push(nft);
        }
      });
    }
    gaEvents.loadBullsharkNfts(nfts.length);

    setBullsharkNfts(nfts);
  }, [wallet]);

  /* async function refresh() {
    await delay(2000);

    // console.log('Waited 2s');
    let suiNfts = [];
    if (wallet.contents) {
      suiNfts = wallet.contents.nfts;
    }
    const talofaNFTs = [];
    suiNfts.forEach((nft) => {
      if (nft.name === 'Beta Frost Generator') {
        talofaNFTs.push(nft);
      }
    });
    setNfts(talofaNFTs);
  } */

  function setBullsharkEnabled() {
    setIsLinked(true);
  }

  function loadNft(nft) {
    setIsConfirming(true);
    setActiveNft(nft);
  }

  function onCloseModal() {
    setIsConfirming(false);
  }

  function discordClicked() {
    gaEvents.discordClicked();
  }

  function onShowLogout(error) {
    setErrorText(error);
    setShowLogout(true);
  }

  useEffect(() => {
    axios
      .post(
        `https://${TITLE_ID}.playfabapi.com/CloudScript/ExecuteFunction`,
        {
          FunctionName: 'GetLinkedWalletAddresses',
        },
        {
          headers: {
            'X-EntityToken': window.sessionStorage.getItem('entity_token'),
          },
        },
      ).then((response) => {
        if (response.data.data.FunctionResult.message !== 'Success') {
          let errorMsg = 'Error fetching connected wallet, please try again';
          // EntityProfileConstraintValidationFailed = 1398
          if (response.data.data.FunctionResult.code === 1398) {
            errorMsg = response.data.data.FunctionResult.message;
            onShowLogout(response.data.data.FunctionResult.message);
          }
          toast.error(
            errorMsg,
            {
              position: toast.POSITION.BOTTOM_RIGHT,
            },
          );
        }
        if (response.data.data.FunctionResult.result != null) {
          setConnectedWallet(response.data.data.FunctionResult.result.suiExternalWallet);
        }
        if (wallet.address === connectedWallet) {
          setBullsharkEnabled();
        } else if (connectedWallet != null) {
          setIsDifferentWallet(true);
          setConnectedWallet(connectedWallet);
        }
      });
  }, [wallet, window]);

  Bullshark.propTypes = {
    wallet: PropTypes.shape.isRequired
  };

  return (
    <div>
      <Logout
        isOpen={showLogout}
        logoutErrorText={errorText}
      />
      <div>
        <h1 className="third-header bullshark-header">
          Thanks to all players who participated! Bullshark Quest 3 has officiailly ended.
          {' '}
        </h1>
        <h1 className="third-header bullshark-header">
          <a className="bullshark-link" target="_blank" href="https://quests.mystenlabs.com/" rel="noreferrer">
            If you participated, see your leaderboard placement here
          </a>
          {' '}
        </h1>
        <h1 className="third-header bullshark-header">
          Keep playing Run Legends for more SUI prizes!
          Join our Discord today to participate in our new challenge.
          {' '}
        </h1>
        <a href="https://discord.com/invite/runlegends" target="_blank" rel="noreferrer" onClick={() => discordClicked()}>
          <img className="discord-img" src="discord.png" alt="" />
        </a>

      </div>
    </div>
  );
}

export default Bullshark;
